import React from 'react'

import Person from './people/Person'
import RichPerson from './people/RichPerson'

export default function(props) {
  const { result } = props
  const ResultComponent = result.richResult ? RichPerson : Person

  return (
    <ResultComponent result={result} />
  )
}
